
import Vue from 'vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "ComponentName",
  data(){
    return {
      isExpanded: false,
      isLarge: false,
    }
  },
  methods: {
    handleExpandClick(){
      this.isExpanded = true
    }
  },
  mounted(){
    if((this.$refs.article as Element).clientHeight > 900){
      this.isLarge = true
    }
  },
  components: {
    UiButton,
    UiIcon,
  },
})
